// import axios from 'axios'
import Vue from "vue";
import Vuex from "vuex";
import { baseApiUrl } from "./global";
import { VueEasyJwt } from "vue-easy-jwt";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userLogado: false,
    token: null,
    user: null,
    userName: null,
    vinculo: null,
    matricula: null,
    situacaoFuncionario: null,
    loaderAtivo: false,
    idenPessoa: null,
    urlPDF: null,
    dadosPDF: null,
    tokenrecaptcha: null,
    escalaAnualRhSelecionada: null,
    versaoApi: "1.0.0",
    counterLoader: 0,
    isRefreshMenu: false,
    perfilAcessoSelecionado: null,
    exibirModalTrocaFoto: false,
    expandedProfile: false,
    isPensionista: false,
  },
  getters: {
    getcounterLoader(state) {
      return state.counterLoader;
    },
    isUserLogado(state) {
      // Retorna o estado
      return state.userLogado;
    },
    isloader(state) {
      return state.loaderAtivo;
    },
    getUser(state) {
      let dadosStorageSeplagJson = decodeURI(atob(state.user));
      return state.user ? JSON.parse(dadosStorageSeplagJson) : null;
    },
    getToken(state) {
      return state.token ? JSON.parse(atob(state.token)) : null;
    },
    getIscricao(state) {
      return state.inscricao ? JSON.parse(atob(state.inscricao)) : null;
    },
    getVinculo(state) {
      return state.vinculo ? atob(state.vinculo) : "...";
    },
    getMatricula(state) {
      return state.matricula ? atob(state.matricula) : "Valor default";
    },
    getSituacaoFuncionario(state) {
      return state.situacaoFuncionario;
    },
    getIdenPessoa(state) {
      return state.idenPessoa ? atob(state.idenPessoa) : "Valor default";
    },
    getUrlPDF(state) {
      return state.urlPDF ? atob(state.urlPDF) : null;
    },
    getDadosPDF(state) {
      return state.dadosPDF ? JSON.parse(atob(state.dadosPDF)) : null;
    },
    getTokenrecaptcha(state) {
      return state.tokenrecaptcha;
    },
    getVersaoApi(state) {
      return state.versaoApi;
    },
    getEscalaAnualRhSelecionada(state) {
      return state.escalaAnualRhSelecionada;
    },
    getPerfilAcesso(state) {
      return state.perfilAcessoSelecionado;
    },
    getExibirModalTrocaFoto(state) {
      return state.exibirModalTrocaFoto ? state.exibirModalTrocaFoto : false;
    },
    getExpandedProfile(state) {
      return state.expandedProfile;
    },
    getIsPensionista(state) {
      return state.isPensionista;
    },
  },
  mutations: {
    setUser(state, user) {
      state.userName = user ? user.contaAcesso.nomeApresentacao : null;
      let dadosStorageSeplagJson = encodeURI(JSON.stringify(user));
      state.user = user ? btoa(dadosStorageSeplagJson) : null;
    },
    setToken(state, token) {
      state.token = token ? btoa(token) : null;
    },
    setUserLogado(state, isUserLogado) {
      state.userLogado = isUserLogado;
    },
    setVinculo(state, vinculo) {
      state.vinculo = vinculo ? btoa(vinculo) : null;
    },
    setMatricula(state, matricula) {
      state.matricula = matricula ? btoa(matricula) : null;
    },
    setSituacaoFuncionario(state, situacaoFuncionario) {
      state.situacaoFuncionario = situacaoFuncionario;
    },
    setLoader(state, loaderStatus) {
      state.loaderAtivo = loaderStatus;
    },
    setIdenPessoa(state, idenPessoa) {
      state.idenPessoa = btoa(idenPessoa);
    },
    setUrlPDF(state, urlPDF) {
      state.urlPDF = urlPDF ? btoa(urlPDF) : null;
    },
    setDadosPDF(state, dadosPDF) {
      state.dadosPDF = dadosPDF ? btoa(dadosPDF) : null;
    },
    setTokenrecaptcha(state, tokenrecaptcha) {
      state.tokenrecaptcha = tokenrecaptcha;
    },
    setVersaoApi(state, versaoApi) {
      state.versaoApi = versaoApi;
    },
    setEscalaAnualRhSelecionada(state, escalaAnualRhSelecionada) {
      state.escalaAnualRhSelecionada = escalaAnualRhSelecionada;
    },
    incCounterLoader(state) {
      state.counterLoader++;
    },
    decCounterLoader(state) {
      state.counterLoader--;
    },
    zeraCounterLoader(state) {
      state.counterLoader = 0;
    },
    setPerfilAcesso(state, perfil) {
      state.perfilAcessoSelecionado = perfil;
    },
    setAbrirModalTrocaFoto(state, status) {
      state.exibirModalTrocaFoto = status ? status : false;
    },
    setExpandedProfile(state, expandedProfile) {
      state.expandedProfile = expandedProfile;
    },
    setIsPensionista(state, isPensionista) {
      state.isPensionista = isPensionista;
    },
  },
  actions: {
    logarUsuario(context, payload) {
      let formData = new FormData();
      formData.append("client", process.env.VUE_APP_USERNAME_API);
      formData.append("username", payload.login);
      formData.append("password", payload.senha);
      formData.append("grant_type", "password");

      delete payload.vue.$http.defaults.headers.common["Content-Type"];
      payload.vue.$http.defaults.headers.common[
        "Authorization"
      ] = `Basic ${btoa(
        process.env.VUE_APP_USERNAME_API +
          ":" +
          process.env.VUE_APP_PASSWORD_API
      )}`;

      payload.vue.$http
        .post(`${baseApiUrl}/oauth/token`, formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          },
        })
        .then((res) => {
          payload.vue.$toast.removeAllGroups();

          let LocalStorageSeplag = localStorage.getItem(
            process.env.VUE_APP_USER_KEY
          );

          let storageSeplagJson = null;

          if (LocalStorageSeplag) {
            storageSeplagJson = JSON.parse(atob(LocalStorageSeplag));
          } else {
            storageSeplagJson = {
              token: "",
              [process.env.VUE_APP_NOME_SISTEMA]: {},
            };
          }

          storageSeplagJson.token = res.data;

          storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] = {
            login: payload.login,
          };

          // var userlogado = {
          //     token: JSON.stringify(res.data),
          //     login: payload.login
          // }

          // localStorage.setItem(process.env.VUE_APP_USER_KEY, btoa(JSON.stringify(userlogado)))

          localStorage.setItem(
            process.env.VUE_APP_USER_KEY,
            btoa(JSON.stringify(storageSeplagJson))
          );

          localStorage.setItem("tk", JSON.stringify(storageSeplagJson.token));

          context.commit("setToken", JSON.stringify(storageSeplagJson.token));

          context.dispatch("buscarUsuario", payload.vue);

          if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
            payload.vue.$recaptchaInstance.hideBadge();
          }

          context.commit("setUserLogado", true);

          return true;
        })
        .catch((error) => {
          context.commit("setLoader", false);
          payload.vue.$toast.removeAllGroups();
          if (error.response.data.error_description == "Bad credentials") {
            payload.vue.$toast.add({
              severity: "error",
              summary: "Usuário ou Senha invalida!!",
              life: 3000,
            });
          } else {
            if (error.response.data.error == "unauthorized") {
              payload.vue.$toast.add({
                severity: "error",
                summary: error.response.data.error_description,
                life: 3000,
              });
            } else {
              payload.vue.$toast.add({
                severity: "error",
                summary: "Ocorreu um erro na execução dessa operação",
                life: 3000,
              });
            }
          }

          return false;
        });
    },
    async buscarUsuario(context, vue) {
      let LocalStorageSeplag = localStorage.getItem(
        process.env.VUE_APP_USER_KEY
      );
      let dadosStorageSeplagJson = null;
      if (LocalStorageSeplag) {
        dadosStorageSeplagJson = decodeURI(atob(LocalStorageSeplag));
      }
      let storageSeplagJson = JSON.parse(dadosStorageSeplagJson);
      let res;

      if (
        storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] &&
        storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca
      ) {
        res = storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca;
        return setarVariaveis(res, vue, context);
      } else {
        res = await vue.$http
          .get(`${baseApiUrl}/seguranca/contasacesso/me`)
          .then((res2) => res2)
          .catch((err) => err);

        if (res.status == 200) {
          storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] = {
            ...storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA],
            seguranca: res.data,
          };
          //let dadosStorageSeplagJson = JSON.stringify(storageSeplagJson).replaceAll('’',"'")
          let dadosStorageSeplagJson = encodeURI(
            JSON.stringify(storageSeplagJson)
          );
          localStorage.setItem(
            process.env.VUE_APP_USER_KEY,
            btoa(dadosStorageSeplagJson)
          );
          return setarVariaveis(res.data, vue, context);
        } else {
          context.dispatch("logoutUsuario");
          return false;
        }
      }

      async function setarVariaveis(res, vue, context) {
        context.commit("setUser", res);
        context.commit(
          "setVinculo",
          res.dadosUsuariosCustomizados.vinculoERP.numrVinculo
        );
        context.commit(
          "setMatricula",
          res.dadosUsuariosCustomizados.vinculoERP.numrMatricula
        );
        context.commit("setIdenPessoa", res.contaAcesso.pessoa.idenPessoa);
        context.commit(
          "setSituacaoFuncionario",
          res.dadosUsuariosCustomizados.vinculoERP.statVinculo
        );

        //verifica se Possui um Vinculo Pensinista
        if (res.dadosUsuariosCustomizados.vinculoERP.numrPensionista != 0) {
          context.commit("setIsPensionista", true);
        } else {
          context.commit("setIsPensionista", false);
        }

        if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
          await vue.$recaptchaLoaded();
          vue.$recaptchaInstance.hideBadge();
        }
        if (res.contaAcesso.perfis.length > 0) {
          context.commit("setPerfilAcesso", null);
          for (var i = 0; i < res.contaAcesso.perfis.length; i++) {
            if (
              res.contaAcesso.perfis[i].perfilAcesso.nivelAcesso == "SISTEMA"
            ) {
              context.commit("setPerfilAcesso", "SISTEMA");
              break;
            } else if (
              res.contaAcesso.perfis[i].perfilAcesso.nivelAcesso == "CENTRAL"
            ) {
              if (
                vue.$store.getters.getPerfilAcesso != "SISTEMA" &&
                vue.$store.getters.getPerfilAcesso != "CENTRAL"
              ) {
                context.commit("setPerfilAcesso", "CENTRAL");
              }
            } else if (
              res.contaAcesso.perfis[i].perfilAcesso.nivelAcesso == "SETORIAL"
            ) {
              if (
                vue.$store.getters.getPerfilAcesso != "SISTEMA" &&
                vue.$store.getters.getPerfilAcesso != "CENTRAL" &&
                vue.$store.getters.getPerfilAcesso != "SETORIAL"
              ) {
                context.commit("setPerfilAcesso", "SETORIAL");
              }
            } else if (
              res.contaAcesso.perfis[i].perfilAcesso.nivelAcesso == "CHEFIA"
            ) {
              if (
                vue.$store.getters.getPerfilAcesso != "SISTEMA" &&
                vue.$store.getters.getPerfilAcesso != "CENTRAL" &&
                vue.$store.getters.getPerfilAcesso != "SETORIAL" &&
                vue.$store.getters.getPerfilAcesso != "CHEFIA"
              ) {
                context.commit("setPerfilAcesso", "CHEFIA");
              }
            } else {
              if (
                vue.$store.getters.getPerfilAcesso != "SISTEMA" &&
                vue.$store.getters.getPerfilAcesso != "CENTRAL" &&
                vue.$store.getters.getPerfilAcesso != "SETORIAL" &&
                vue.$store.getters.getPerfilAcesso != "CHEFIA"
              ) {
                context.commit(
                  "setPerfilAcesso",
                  res.contaAcesso.perfis[i].perfilAcesso.nivelAcesso
                );
              }
            }
          }
        }

        vue.$http
          .get(`${baseApiUrl}/publicos/sistemas/versao`)
          .then((response) => {
            context.commit("setVersaoApi", response.data);
          });
        return true;
      }
    },
    logoutUsuario(context) {
      localStorage.removeItem(process.env.VUE_APP_USER_KEY);
      localStorage.removeItem("tk");
      context.commit("setUserLogado", false);
      context.commit("setToken", null);
      context.commit("setUser", null);
      context.commit("setExpandedProfile", false);
    },
    async refreshToken(context, vue) {
      var formData = new URLSearchParams();
      formData.append("grant_type", "refresh_token");

      delete vue.$http.defaults.headers.common["Content-Type"];

      vue.$http.defaults.headers.common["Authorization"] = `Basic ${btoa(
        process.env.VUE_APP_USERNAME_API +
          ":" +
          process.env.VUE_APP_PASSWORD_API
      )}`;

      if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
        await vue.$recaptchaLoaded();
      }
      let res = await vue.$http
        .post(`${baseApiUrl}/oauth/token`, formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
          },
        })
        .catch(() => {
          context.dispatch("logoutUsuario");
          if (process.env.VUE_APP_ATIVAR_GOOGLE_TOOLS != "false") {
            vue.$recaptchaInstance.showBadge();
          }
          return false;
        });

      if (res && res.status == 200) {
        let token = JSON.parse(
          decodeURI(atob(localStorage.getItem(process.env.VUE_APP_USER_KEY)))
        );
        token.token = JSON.stringify(res.data);
        localStorage.setItem(
          process.env.VUE_APP_USER_KEY,
          btoa(JSON.stringify(token))
        );
        context.commit("setToken", JSON.stringify(res.data));
        context.commit("setUserLogado", true);
        return true;
      }
    },
    async verificaToken(context, vue) {
      let jwt = new VueEasyJwt();
      if (jwt.isExpired(context.getters.getToken.access_token)) {
        await context.dispatch("refreshToken", vue);
      }
    },
    async updateFoto(context, status) {
      context.commit("setAbrirModalTrocaFoto", status);
    },
  },
});

export default store;
